"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _select = _interopRequireDefault(require("../select"));
var _Button = _interopRequireDefault(require("../button/Button"));
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = require("../tooltip");
var _misc = require("../misc");
var _SimpleRule2 = _interopRequireDefault(require("./SimpleRule.style"));
var _Operator = _interopRequireDefault(require("./Operator"));
var _Value = _interopRequireDefault(require("./Value"));
var _helpers = require("./helpers");
var _helpers2 = require("../select/helpers");
var _excluded = ["disabled", "type", "valuesUrl"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SimpleRule = /*#__PURE__*/function (_React$Component) {
  function SimpleRule(params) {
    var _this;
    _classCallCheck(this, SimpleRule);
    _this = _callSuper(this, SimpleRule, [params]);
    _defineProperty(_this, "onRuleChange", function (ruleElementType, val, valueOperands) {
      var _this$state = _this.state,
        rule = _this$state.rule,
        ruleOperatorProps = _this$state.ruleOperatorProps,
        ruleValueProps = _this$state.ruleValueProps;
      var newRule = R.clone(rule);
      var newRuleValueProps = ruleValueProps;
      var newRuleOperatorProps = ruleOperatorProps;
      var elementValue = val;
      if (ruleElementType === 'operator') {
        if (rule.operator === elementValue) return;
        newRule.operator = elementValue;
        newRuleValueProps.disabled = false;
        newRule.values = [];
      } else if (ruleElementType === 'variable') {
        if (rule.variable === elementValue) return;
        newRuleValueProps.disabled = !rule.operator;
        newRuleValueProps.type = elementValue.type;
        newRuleValueProps.valuesUrl = elementValue.valuesUrl;
        _this.props.onLookupData(elementValue.valuesUrl);
        newRule.variable = elementValue;
        newRule.values = [];
        newRuleOperatorProps.disabled = false;
      } else if (ruleElementType === 'value') {
        if (rule.values === elementValue) return;
        newRule.values = R.isEmpty(R.prop(0, elementValue)) ? [] : elementValue;
      }
      _this.props.onRuleChange(newRule, _this.props.pathKeys, valueOperands);
      _this.setState({
        rule: newRule,
        ruleValueProps: newRuleValueProps,
        ruleOperatorProps: newRuleOperatorProps
      });
    });
    var originalRule = params.rule,
      variableOptions = params.variableOptions,
      onLookupData = params.onLookupData,
      operatorOptions = params.operatorOptions;
    var _rule = R.clone(originalRule);
    var _ruleValueProps = R.clone(_helpers.defaultRuleValueProps);
    variableOptions.forEach(function (option) {
      if (_rule.variable && _rule.variable === option.value) {
        _ruleValueProps.type = option.type;
        _ruleValueProps.valuesUrl = option.valuesUrl;
        if (option.valuesUrl) onLookupData(option.valuesUrl);
        _ruleValueProps.disabled = false;
      }
    });
    operatorOptions.forEach(function (option) {
      if (_rule.operator && _rule.operator === option.values) {
        _rule.operator = _objectSpread({}, option);
      }
    });
    _this.state = {
      rule: _objectSpread(_objectSpread({}, _helpers.defaultRule), _rule),
      ruleValueProps: _objectSpread(_objectSpread({}, _ruleValueProps), {
        disabled: !_rule.operator || !_rule.variable
      }),
      ruleOperatorProps: _objectSpread(_objectSpread({}, _helpers.defaultRuleOperatorsProps), {
        disabled: !_rule.variable
      })
    };
    return _this;
  }
  _inherits(SimpleRule, _React$Component);
  return _createClass(SimpleRule, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        variableOptions = _this$props.variableOptions,
        operatorOptions = _this$props.operatorOptions,
        lookUpValues = _this$props.lookUpValues,
        isSelected = _this$props.isSelected,
        onAddNew = _this$props.onAddNew,
        onDuplicate = _this$props.onDuplicate,
        onDelete = _this$props.onDelete,
        pathKeys = _this$props.pathKeys,
        isDuplicateDisabled = _this$props.isDuplicateDisabled,
        maxDepth = _this$props.maxDepth,
        parentOperator = _this$props.parentOperator,
        labels = _this$props.labels,
        errors = _this$props.errors,
        hideMenu = _this$props.hideMenu,
        searchableAction = _this$props.searchableAction,
        rule = _this$props.rule,
        onClick = _this$props.onClick;
      var _this$state$ruleValue = this.state.ruleValueProps,
        disabled = _this$state$ruleValue.disabled,
        type = _this$state$ruleValue.type,
        valuesUrl = _this$state$ruleValue.valuesUrl,
        otherRuleValueProps = _objectWithoutProperties(_this$state$ruleValue, _excluded);
      var _this$state$rule = this.state.rule,
        variable = _this$state$rule.variable,
        operator = _this$state$rule.operator,
        values = _this$state$rule.values;
      var operatorValue = R.find(R.propEq('value', operator))(operatorOptions);
      var menuItems = [];
      var allowsMultipleSelect = R.prop('allowsMultipleSelect', operatorValue);
      if (!isDuplicateDisabled) {
        menuItems.push({
          name: labels.ELIGIBILITY_DUPLICATE_RULE || 'Duplicate',
          icon: 'ion-ios-copy',
          onClick: function onClick() {
            onDuplicate(pathKeys);
          }
        });
      }
      menuItems.push({
        name: labels.ELIGIBILITY_DELETE_RULE || 'Delete',
        icon: 'ion-trash-b',
        onClick: function onClick() {
          onDelete('rule', pathKeys);
        }
      });
      return /*#__PURE__*/_react["default"].createElement(_SimpleRule2["default"], {
        key: id,
        id: id,
        isSelected: isSelected,
        hasErrors: !R.isEmpty(errors),
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element value-element"
      }, /*#__PURE__*/_react["default"].createElement(_select["default"], {
        disabled: R.prop('disabled', this.props),
        valueRenderer: function valueRenderer(option) {
          return SimpleRule.renderSelectedValue(option, pathKeys.join('-'));
        },
        id: "".concat(id, "Variable"),
        searchable: true,
        value: variable,
        options: variableOptions,
        placeholder: labels.LEFT_OPERAND_PLACEHOLDER || 'Variable',
        onChange: function onChange(val) {
          _this2.onRuleChange('variable', val);
        },
        errors: R.prop('variable', errors)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element rule-operator"
      }, /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
        id: "".concat(id, "Operator"),
        options: operatorOptions,
        onChange: function onChange(val) {
          _this2.onRuleChange('operator', val.value);
        },
        value: operatorValue,
        disabled: this.state.ruleOperatorProps.disabled || R.prop('disabled', this.props),
        labels: labels,
        errors: R.prop('operator', errors)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element rule-value"
      }, /*#__PURE__*/_react["default"].createElement(_Value["default"], _extends({
        variableOperands: rule.variableOperands,
        disabled: disabled || R.prop('disabled', this.props),
        id: "".concat(id, "Value"),
        onChange: function onChange(val, valueOperands) {
          _this2.onRuleChange('value', val, valueOperands);
        },
        type: type,
        lookUpValues: valuesUrl && lookUpValues ? lookUpValues[valuesUrl] : [],
        value: values,
        labels: labels,
        valueRenderer: function valueRenderer(option) {
          return SimpleRule.renderSelectedValue(option, "".concat(pathKeys.join('-'), "Value"));
        },
        allowsMultipleSelect: allowsMultipleSelect,
        operatorValue: operatorValue,
        errors: R.prop('values', errors),
        searchableAction: searchableAction
      }, otherRuleValueProps))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttons-wrapper"
      }, isSelected && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "".concat(id, "AndButton"),
        className: "rule-buttons",
        action: function action() {
          onAddNew('AND', pathKeys);
        },
        medium: true,
        disabled: pathKeys && pathKeys.length >= maxDepth && parentOperator === 'OR' || R.prop('disabled', this.props)
      }, labels.ELIGIBILITY_AND_OPERATOR || 'AND'), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "".concat(id, "OrButton"),
        className: "rule-buttons",
        action: function action() {
          onAddNew('OR', pathKeys);
        },
        medium: true,
        disabled: pathKeys && pathKeys.length >= maxDepth && parentOperator === 'AND' || R.prop('disabled', this.props),
        type: "naked"
      }, labels.ELIGIBILITY_OR_OPERATOR || 'OR')), hideMenu && pathKeys[0] === 0 ? '' : /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
        disabled: R.prop('disabled', this.props),
        className: "rule-menu-list",
        menuItems: menuItems,
        position: "top-right",
        id: "".concat(id, "MenuList"),
        ignoreSingleItemLogic: true
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-more-vertical",
        id: "".concat(id, "MenuList")
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!R.equals(props.rule, state.rule)) {
        return {
          rule: _objectSpread({}, props.rule)
        };
      }
      return null;
    }
  }]);
}(_react["default"].Component);
_defineProperty(SimpleRule, "renderSelectedValue", function (option, id) {
  var selectedLabel = (0, _helpers2.getSelectedValueLabel)(option);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(id, "EligibilityTooltip")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ellipsis-overflow",
    "data-tip": selectedLabel,
    "data-for": "".concat(id, "EligibilityTooltip"),
    "data-offset": "{ 'left':10}",
    "data-place": "top"
  }, selectedLabel));
});
SimpleRule.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  hideMenu: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  /** A list with the position trail of the current rule */
  pathKeys: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  /** The parent operator */
  parentOperator: _propTypes["default"].string.isRequired,
  /** A list of system variables */
  variableOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** A list of operators */
  operatorOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** A list of posible options for a system variable (when a system variable has lookup data) */
  lookUpValues: _propTypes["default"].shape({}),
  /** A callback to call when selecting a system variable with lookup data */
  onLookupData: _propTypes["default"].func,
  /** Callback to perform when the rule elements change */
  onRuleChange: _propTypes["default"].func.isRequired,
  /** Callback to perform when duplicating a simple rule */
  onDuplicate: _propTypes["default"].func.isRequired,
  /** Callback to perform when deleting a simple rule */
  onDelete: _propTypes["default"].func.isRequired,
  /** Callback for when clicking the OR or AND buttons */
  onAddNew: _propTypes["default"].func.isRequired,
  /** Flag to indicate weather the current rule is selected */
  isSelected: _propTypes["default"].bool,
  /** Flag to indicate weather to disabled the duplicate item (eg. Duplicate first IF statement) */
  isDuplicateDisabled: _propTypes["default"].bool,
  /** Max rules depth value */
  maxDepth: _propTypes["default"].number,
  /** Object containing error messages for the elements in the rule */
  errors: _propTypes["default"].shape({}),
  /** CMS labels */
  labels: _propTypes["default"].shape({
    LEFT_OPERAND_PLACEHOLDER: _propTypes["default"].string,
    ELIGIBILITY_OR_OPERATOR: _propTypes["default"].string,
    ELIGIBILITY_AND_OPERATOR: _propTypes["default"].string,
    ELIGIBILITY_DELETE_RULE: _propTypes["default"].string,
    ELIGIBILITY_DUPLICATE_RULE: _propTypes["default"].string
  }),
  searchableAction: _propTypes["default"].func.isRequired,
  rule: _propTypes["default"].shape({
    variableOperands: _propTypes["default"].oneOfType([_propTypes["default"].array])
  }).isRequired
};
SimpleRule.defaultProps = {
  hideMenu: false,
  disabled: false,
  lookUpValues: null,
  errors: {},
  onLookupData: undefined,
  isSelected: false,
  isDuplicateDisabled: false,
  maxDepth: 3,
  labels: {}
};
var _default = exports["default"] = SimpleRule;